import React from 'react';
import { useSelector } from 'react-redux';

import GroupSuggestionsCalendarConnected from './GroupSuggestionsCalendarConnected/GroupSuggestionsCalendarConnected';
import SuggestionsCalendarDisconnected from '../SuggestionsCalendarDisconnected/SuggestionsCalendarDisconnected';

import './AddGroupSugestionsSection.scss';

type Props = {
  onWorkspaceNameSet: Function;
  onInviteesChange: Function;
  onSetRecurringMeetingId: Function;
  onSetIsSuggestionOpened: Function;
};

function AddGroupSugestionsSection({
  onWorkspaceNameSet,
  onInviteesChange,
  onSetRecurringMeetingId,
  onSetIsSuggestionOpened,
}: Props) {
  const isCalendarConnected = useSelector(state =>
    Boolean(state.data_sources.find(ds => ds.isCalendar && ds.connected))
  );

  return (
    <div className="add-group-sugestions-section d-flex flex-column mt-4">
      {isCalendarConnected ? (
        <GroupSuggestionsCalendarConnected
          onWorkspaceNameSet={onWorkspaceNameSet}
          onInviteesChange={onInviteesChange}
          onSetRecurringMeetingId={onSetRecurringMeetingId}
          onSetIsSuggestionOpened={onSetIsSuggestionOpened}
        />
      ) : (
        <SuggestionsCalendarDisconnected />
      )}
    </div>
  );
}

export default AddGroupSugestionsSection;
